import Chart, { registerables } from 'chart.js/auto';

// Function to get a CSS variable value and convert it to rgba
function getCSSVariableColor(variable, opacity = 1) {
    const hex = getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
    if (!hex.startsWith('#')) return hex; // Return as-is if it's not in hex format

    // Convert hex to RGB
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

function createChart(canvasId, datasets) {
    Chart.defaults.color = '#FFFFFF';
    Chart.defaults.font.size = 16;

    // Extract unique years for the x-axis labels
    const labels = datasets[0].data.map(row => row.year);

    // Use CSS variables for colors
    const colors = {
        theme: {
            light: getCSSVariableColor('--theme-light', 1),
            deep: getCSSVariableColor('--theme-light', 0.8), // Adjust opacity as needed
            opacity: getCSSVariableColor('--theme-light', 0.3),
            transparent: getCSSVariableColor('--theme-light', 0)
        },
        white: {
            default: 'rgba(255,255,255,1)',
            opacity: 'rgba(255,255,255,0.3)',
            transparent: 'rgba(255,255,255,0)'
        }
    };

    const ctx = document.getElementById(canvasId).getContext("2d");
    ctx.canvas.height = 128;

    // Create gradients using dynamic colors
    var gradient1 = ctx.createLinearGradient(0, 0, 0, 400);
    gradient1.addColorStop(0, colors.theme.light);
    gradient1.addColorStop(0.2, colors.theme.opacity);
    gradient1.addColorStop(0.5, colors.theme.transparent);
    gradient1.addColorStop(1, colors.theme.transparent);

    var gradient2 = ctx.createLinearGradient(0, 0, 0, 400);
    gradient2.addColorStop(0, colors.white.default);
    gradient2.addColorStop(0.2, colors.white.opacity);
    gradient2.addColorStop(0.5, colors.white.transparent);
    gradient2.addColorStop(1, colors.white.transparent);

    // Map each dataset to Chart.js format
    const chartDatasets = datasets.map((dataset, index) => ({
        label: dataset.label,
        data: dataset.data.map(row => row.count),
        fill: true,
        backgroundColor: index === 0 ? gradient1 : gradient2,
        borderColor: index === 0 ? colors.theme.light : colors.white.default,
        borderWidth: 1,
        pointRadius: 0,
        tension: 0.2
    }));

    // Create the chart instance
    new Chart(document.getElementById(canvasId), {
        type: 'line',
        data: {
            labels: labels,
            datasets: chartDatasets
        },
        options: {
            plugins: {
                legend: {
                    position: 'top',
                    align: 'end',
                    labels: {
                        useBorderRadius: true,
                        borderRadius: 2,
                        boxHeight: 16,
                        boxWidth: 16,
                        font: {
                            family: "'Lexend Deca', sans-serif",
                            size: 16
                        },
                        padding: 17
                    },
                }
            },
            layout: {
                padding: 0
            },
            scales: {
                x: {
                    grid: {
                        color: colors.theme.deep,
                        display: false
                    },
                    ticks: {
                        align: 'end'
                    }
                },
                y: {
                    grid: {
                        display: true,
                        color: colors.theme.deep
                    },
                }
            },
        },
    });
}

(async function () {
    const chartElements = document.querySelectorAll('canvas[data-dataset]');

    chartElements.forEach(canvas => {
        const dataset = JSON.parse(canvas.getAttribute('data-dataset'));
        const canvasId = canvas.id;

        createChart(canvasId, dataset);
    });
})();
